import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n";
import { useTheme } from "../../../theme";
import "./HeroSection.css";

const HeroSection = () => {
  const navigate = useNavigate();
  const { t, withLanguage } = useLanguage();
  const { isDark } = useTheme();

  const handleGetStarted = () => {
    navigate(withLanguage("/contact"));
  };

  return (
    <div>
      <section className="hero-container">
        <div className="hero-text">
          <h1 className="hero-title">{t('hero.titleLine1')}<br /> {t('hero.titleLine2')}</h1>
          <button className="hero-button" onClick={handleGetStarted}>
            {t('hero.cta')}
          </button>
        </div>

        <div className="hero-image">
          <img
            src={isDark ? "/images/hero-image-dark.png" : "/images/hero-image-webp.webp"}
            alt={t('hero.imageAlt')}
          />
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
